<template>
  <div class="foot-con">
    <div class="content">
      <!-- 联系咨询 -->
      <div class="contact-group">
        <el-image src="static/images/TPersonalNav/ty-icon.png"></el-image>
        <div class="block">
          售前咨询：{{ phone }}
        </div>
        <div class="block">
          公司地址：{{ address }}
        </div>
      </div>
      <div class="icon-group">
        <div class="title">下载</div>
        <div class="context">
          <a href="javascript:void(0);" @click="toLink('/agreement/download?id=softDownloadSf', true)"
            target="_blank">室分设计软件</a>
          <a href="javascript:void(0);" @click="toLink('/agreement/download?id=softDownloadCs', true)">传输设计软件</a>
        </div>
      </div>
      <div class="icon-group">
        <div class="title">关于我们</div>
        <div class="context">
          <a href="http://www.tyicd.com/page17">天越简介</a>
          <a href="http://www.tyicd.com/page19">企业文化</a>
          <a href="http://www.tyicd.com/page20">公司动态</a>
        </div>
      </div>
      <div class="icon-group">
        <div class="title">联系我们</div>
        <div class="context">
          <a href="http://www.tyicd.com/page22">人才招聘</a>
          <a href="http://www.tyicd.com/page23">团队建设</a>
          <a href="http://www.tyicd.com/page27">联系我们</a>
        </div>
      </div>
      <div class="icon-group">
        <div class="title">其他</div>
        <div class="context">
          <a href="/#/agreement/privacy" target="_blank">用户隐私声明</a>
          <a href="/#/agreement/trade" target="_blank">在线订购协议</a>
          <a href="/#/agreement/pay" target="_blank">充值/支付服务条款</a>
        </div>
      </div>
      <div class="qr-group">
        <div class="scan">
          <el-image class="qr-code" src="static/images/ty-qc.jpg"></el-image>
          <div class="qr-des">关注我们</div>
        </div>
      </div>
    </div>
    <div class="foot-box">
      版权所有 广州天越 粤ICP备09036078号 <span style="font-family:arial;">&copy; </span> Copyright 2008 - 2022.tycad.cn. All
      Rights Reserved
    </div>
  </div>
</template>

<script>
import { IndexPageConfig } from '@/utils/config'

export default {
  name: 'v-foot',
  props: {
    phone: {
      type: String,
      default: function () {
        return IndexPageConfig.phone
      }
    },
    address: {
      type: String,
      default: function () {
        return IndexPageConfig.address
      }
    }
  },
  data() {
    return {}
  },
  methods: {
    toLink(link, isNewWindows = false) {
      let url = null
      if (link.indexOf('http') > -1) {
        url = link
      } else {
        let temp = this.$router.resolve({ path: link })
        url = temp.href
      }
      if (isNewWindows) {
        window.open(url, '_blank')
      } else {
        location.href = url
      }
    }
  }
}
</script>

<style scoped lang="scss">
.foot-con {
  width: $width;
  height: 293px;
  background-color: #292c2f;
  font-family: 'Arial Normal', 'Arial';
  font-size: 12px;
  font-weight: 400;
  color: rgba(255, 255, 255, 0.56);
  display: flex;
  // align-items: center;
  flex-direction: column;
  margin: auto;

  .content {
    width: 900px;
    height: 200px;
    display: flex;
    flex-flow: row wrap;
    border-bottom: solid 1px rgba(255, 255, 255, 0.1);
    margin: auto;

    .contact-group {
      width: 260px;
      margin-right: 10px;

      .el-image {
        width: 131px;
        height: 30px;
      }

      .block {
        margin-top: 30px;
      }

    }

    .icon-group {
      width: 100px;
      margin: 0 15px;

      .title {
        font-size: 16px;
        font-weight: bold;
        line-height: 30px;
        color: #FFFFFF;
        padding-bottom: 10px;
      }

      .context {
        a {
          display: block;
          padding: 5px 0;
        }
      }
    }

    .qr-group {
      width: 100px;
      margin-left: 10px;

      .scan {
        width: 100px;

        .qr-code {
          width: 100px;
          height: 100px;
        }

        .qr-des {
          text-align: center;
          margin-top: 5px;
        }
      }
    }
  }

  .foot-box {
    width: $width;
    height: 30px;
    text-align: center;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/base/v-foot.vue